<!-- LAYOUT 3 COLUMNAS -->
<div class="h-screen flex bg-gray-50">
  <!-- ==================== COLUMNA IZQUIERDA: LISTA ==================== -->
  <div class="w-[19.44rem] flex-shrink-0 bg-white border-r border-gray-200">
    <app-lista-paraclinicos
      [paraclinicos]="paraclinicosFiltrados"
      [paraclinicosCompletos]="paraclinicos"
      [paraclinicoSeleccionado]="estado.paraclinicoSeleccionado"
      [cargando]="estado.cargando"
      (paraclinicoSelected)="onParaclinicoSeleccionado($event)"
      (nuevoParaclinico)="onNuevoParaclinico()"
      (filtrosChange)="onFiltrosChange($event)"
      (volver)="onVolver()"
    ></app-lista-paraclinicos>
  </div>

  <!-- ==================== COLUMNA CENTRO: DETALLE ==================== -->
  <div class="flex-1 bg-white overflow-hidden">
    <app-detalle-paraclinico
      [paraclinicoSeleccionado]="estado.paraclinicoSeleccionado"
      [modoVista]="estado.modoVista"
      [appointmentId]="appointmentId"
      [patientId]="patientId"
      (paraclinicoGuardado)="onParaclinicoGuardado($event)"
      (paraclinicoActualizado)="onParaclinicoActualizado($event)"
      (cancelar)="onCancelarEdicion()"
    ></app-detalle-paraclinico>
  </div>

  <!-- ==================== COLUMNA DERECHA: PERFIL PACIENTE ==================== -->
  <div class="w-[30rem] flex-shrink-0 bg-white border-l border-gray-200">
    <!-- Forzar re-creación del componente cuando paciente cambie -->
    <ng-container *ngIf="paciente && paciente.id">
      <app-perfil-paciente
        [patient]="paciente"
        [appointmentId]="appointmentId"
        [patientId]="paciente.id.toString()"
      ></app-perfil-paciente>
    </ng-container>

    <!-- Loading state -->
    <div *ngIf="!paciente" class="h-full flex items-center justify-center text-gray-400">
      <div class="text-center">
        <svg class="animate-spin h-12 w-12 mx-auto mb-4 text-purple-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <p class="text-sm">Cargando información del paciente...</p>
      </div>
    </div>
  </div>
</div>

<!-- ==================== LOADING OVERLAY ==================== -->
<div *ngIf="estado.cargando" class="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 flex items-center justify-center">
  <div class="bg-white rounded-xl shadow-lg p-6 flex items-center gap-4">
    <svg class="animate-spin h-8 w-8 text-purple-600" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span class="text-gray-700 font-medium">Cargando paraclínicos...</span>
  </div>
</div>

<!-- ==================== ERROR TOAST ==================== -->
<div
  *ngIf="estado.error"
  class="fixed top-4 right-4 z-50 bg-red-50 border border-red-200 rounded-lg shadow-lg p-4 max-w-md"
>
  <div class="flex items-start gap-3">
    <svg class="w-6 h-6 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <div class="flex-1">
      <p class="text-sm font-medium text-red-800">Error</p>
      <p class="text-sm text-red-700 mt-1">{{ estado.error }}</p>
    </div>
    <button (click)="estado.error = null" class="text-red-400 hover:text-red-600">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>
